module.exports = __webpack_public_path__ + "staticcomp/img/content_3.562e3f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2/7/content_3.png
// module id = 3IMP
// module chunks = 39